export const COLORS = [
  "#1d91d0",
  "#73cfdd",
  "#FFBB28",
  "#FF8042",
  "#03A450",
  "#bc74e0",
  "#EC257A",
  "#a2e5a2",
];

export const LINK_COLOR = "#038743";

export const CATEGORY_BACKGROUND_COLOR = "#E6E6E6";



// WEBPACK FOOTER //
// ./components/employee/benefits/trs/constants.js